<template>
  <div>
    <div v-if="guestCountError" class="guestCount errMessage">
      <div class="title notranslate">{{ locale[guestCountError] }}</div>
    </div>
    <div v-else-if="countList && countList.length > 0" class="guestCount" :class="{single: countLength <= 1, keypadMode: setCount}">
      <div v-if="countTitle" class="title">{{ countTitle[lang] }}</div>
      <div v-else class="title notranslate">{{ locale.title_number_of_guest }}</div>
      <div class="counterList">
        <div
          v-for="group in filteredCountList"
          :key="group.groupId"
          class="counter">
          <div v-if="setCount ? countList.length > 1 : countLength > 1" class="name">
            {{ group.groupName[lang] }}
          </div>
          <div class="countBox notranslate">
            <button
              type="button"
              class="btnCount btnMinus"
              @click="decGroupCount(group.groupId)">
            </button>
            <span class="count">
              {{ group.count }}
            </span>
            <button
              type="button"
              class="btnCount btnPlus"
              @click="incGroupCount(group.groupId)">
            </button>
          </div>
          <button
            v-if="!setCount"
            type="button"
            class="btn btnWhite btnRound btnInput notranslate"
            @click="setGroupCount(group.groupId, true)">
            {{ locale.direct_input }}
          </button>
        </div>
      </div>
      <button
        v-if="!setCount"
        type="button"
        class="btn btnFull btnRound btnConfirm notranslate"
        :style="getDefaultBtnStyle"
        :disabled="!isValid"
        @click="saveGuestCount">
        {{ locale.complete_select }}
      </button>
      <transition name="keypad">
        <div
          v-if="setCount"
          class="keypad notranslate">
          <div class="keypadBox">
            <button
              v-for="num in keys"
              :key="num"
              :data-num="num"
              type="button"
              class="key"
              @click="setKeypad(num)">
              {{ num }}
            </button>
          </div>
          <div class="btns">
            <button type="button" class="btn btnRound btnWhite" @click="closeGroupCount">{{ locale.cancel }}</button>
            <button type="button" class="btn btnRound" :disabled="!isValidConfirm()" @click="confirmGroupCount">{{ locale.confirm }}</button>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>

export default {
  name: 'guestCount',
  props: [
    'locale',
    'lang',
    'responsive',
    'isPublic',
    'shopPageId',
    'guestCountError'
  ],
  computed: {
    shopType () {
      return this.$route.params.shopType
    },
    getGuestInfo () {
      const authInfo = this.$store.getters['authentication/getAuthInfo'] //파라미터 정보
      const guestInfo = this.$store.getters['guest/getGuestUserInfo']
      return {
        ...authInfo,
        ...guestInfo
      }
    },
    getDefaultBtnStyle () {
      return this.$store.getters['common/getDefaultBtnStyle']
    },
    isValid () {
      const totalCount = this.countList.map(x => (x.count && Number(x.count)) || 0)
      return totalCount.reduce((a, b) => a + b, 0) > 0
    },
    filteredCountList () {
      const list = this.countList
      const countGroup = this.setCount
      return (list && list.filter(x => countGroup ? countGroup && x.groupId === countGroup : true)) || []
    },
    countLength () {
      return this.filteredCountList.length
    },
  },
  watch: {
    async '$route' (to, from, next) {
      if ((to.name === from.name) && (to.params.shopPageId !== from.params.shopPageId)) {
        this.init()
      }
    }
  },
  beforeDestroy () {
    this.$store.commit('shop/setShopGuestCount', null)
  },
  created () {
    this.init()
  },
  data () {
    return {
      isAuth: false,
      countTitle: null,
      countList: [],
      keys:[
        1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 'del'
      ],
      setCount: null,
      firstEdit: false,
      originSetCount: ''
    }
  },
  methods: {
    async init () {
      await this.checkAuth()
      if (!this.shopPageId) {
        alert('Not found shopPageId.')
        this.$router.push({ name: 'main' })
      } else if (!this.isAuth) {
        alert('Expired table.')
      } else {
        const guestCountInfo = await this.getShopGuestInfo()
        if (guestCountInfo && (guestCountInfo.guestInfo || guestCountInfo.preGuestInfo)) {
          if (this.guestCountError) return
          this.close()
        } else {
          // 스토어에서 쓴다면 전체화면이므로 다국어버튼이 노출되어야 함
          this.$store.commit('shop/setShopGuestCount', this.shopPageId)
          this.setGuestCount()
        }
      }
    },
    track () {
      const site = this.$store.state.authentication.site
      const routerPath = this.$route.path
      const path = `${site}${routerPath}`
      this.$gtag.pageview({
        page_path: path,
        page_title: 'guest-count'
      })
    },
    async checkAuth () {
      const getAuthInfo = this.$store.getters['authentication/getAuthInfo']
      const key = getAuthInfo.k
      const space = getAuthInfo.space
      const isKeyValid = !(getAuthInfo.otavalid && getAuthInfo.otavalid === 'false')
      this.isAuth = key && space && isKeyValid
      return this.isAuth
    },
    async getShopGuestInfo () {
      try {
        const shopPageId = this.shopPageId
        const shopCatCode = this.$store.getters['shop/getShopCatCode'](shopPageId)
        const guestCount = shopCatCode ? await this.$store.dispatch('order/getShopGuestInfo', shopCatCode) : null
        return guestCount
      } catch {

      }
    },
    setGuestCount () {
      const shopGuestSetting = this.$store.getters['shop/getShopGuestSettings'](this.shopPageId)
      const guestSetting = shopGuestSetting && shopGuestSetting.active ? shopGuestSetting : null
      if (guestSetting) {
        this.countTitle = guestSetting.title
        this.countList = guestSetting.settingItems.map(group => {
          return {
            groupId: group.groupId,
            groupName: group.groupName,
            min: `${group.settings.minNum}`,
            max: `${group.settings.maxNum}`,
            count: `${group.settings.initNum}` || '0'
          }
        })
      } else {
        this.replaceToShop()
      }
    },
    incGroupCount (groupId) {
      const group = this.countList.find(x => x.groupId === groupId)
      function incCount (groupCount, max) {
        const count = Number(groupCount)
        max = Number(max)
        return count >= max ? max : count + 1
      }
      if (group) {
        this.updateGroupCount(groupId, incCount(group.count, group.max))
      }
    },
    decGroupCount (groupId) {
      const group = this.countList.find(x => x.groupId === groupId)
      function decCount (groupCount, min) {
        const count = Number(groupCount)
        min = Number(min)
        return count <= min ? min : count - 1
      }
      if (group) {
        this.updateGroupCount(groupId, decCount(group.count, group.min))
      }
    },
    setGroupCount (groupId, isStart) {
      this.firstEdit = isStart
      this.originSetCount = groupId ? this.countList.find(x => x.groupId === groupId).count : null
      this.setCount = groupId || null
    },
    closeGroupCount () {
      const groupId = this.setCount
      const originSetCount = this.originSetCount
      this.updateGroupCount(groupId, originSetCount)
      this.setGroupCount(null)
    },
    confirmGroupCount () {
      this.setGroupCount(null)
    },
    async saveGuestCount () {
      this.$store.commit('loading', true)
      // 보내기 전 checkOrderStatus 해야함 (ota가 바뀔수 있으므로)
      try {
        const data = {
          pageId: this.shopPageId,
          guestInfos: this.countList.filter(group => {
            return Number(group.count) > 0
          }).map(group => {
            return {
              groupId: group.groupId,
              count: Number(group.count)
            }
          })
        }
        const res = await this.$store.dispatch('order/setShopGuestInfo', data)
        if (res && res.status === 200) {
          const guestData = {
            billingStayNo: '',
            guestInfo: {
              guestInfos: data.guestInfos,
              orderUUID: ''
            },
            startTime: new Date().toISOString()
          }
          this.$store.commit('shop/setShopGuest', guestData)
          this.close()
        }
      } catch (ex) {
        console.log(ex)
      } finally {
        this.$store.commit('loading', false)
      }
    },
    setKeypad (num) {
      const firstEdit = this.firstEdit
      const groupId = this.setCount
      const group = this.countList.find(x => x.groupId === groupId)
      function updateCount (count, key, opts = { min: 0, max: 99 }, firstEdit) {
        const { min, max } = opts;
        const maxDigits = String(max).length;   // 허용 자릿수
        const isDigit = /^\d$/.test(key);

        // 내부 편집용 문자열(빈값 허용)
        let s = (count === null || typeof count === 'undefined')
          ? ''
          : String(count);

        // 1) 삭제키
        if (key === 'del') {
          if (!s) return null;          // 이미 빈값이면 그대로
          s = s.slice(0, -1);           // 마지막 자리 제거
          if (!s) return null;          // 한 자리였으면 → 빈값(null)

          const n = parseInt(s, 10);
          return Number.isFinite(n) ? n : null;
        }

        // 2) 숫자가 아니면 변화 없음
        if (!isDigit) return count;

        // 3) 첫 입력이거나 firstEdit인 경우 → 새로 시작
        if (firstEdit || !s) {
          let n = parseInt(key, 10);
          if (!Number.isFinite(n)) return count;

          if (n > max) n = max;
          if (n < min) n = min;
          return n;
        }

        // 4) 자리수 제한: 이미 maxDigits 만큼 채워져 있음
        if (s.length >= maxDigits) {
          // 👉 max가 한 자리 수일 때는 “덮어쓰기” 모드
          if (maxDigits === 1) {
            let n = parseInt(key, 10);
            if (!Number.isFinite(n)) return count;

            if (n > max) n = max;
            if (n < min) n = min;
            return n;
          }

          // 두 자리 이상(예: max=12, maxDigits=2)인 경우에는
          // 더 입력 못하게 막음
          return count;
        }

        // 5) 기존 숫자에 새 숫자 붙여서 후보 만들기
        const candidateStr = (s === '0') ? key : (s + key);
        let n = parseInt(candidateStr, 10);
        if (!Number.isFinite(n)) return count;

        if (n > max) n = max;
        if (n < min) n = min;
        return n;
      }


      if (group) {
        this.updateGroupCount(groupId, updateCount(group.count, num, {min: group.min, max: group.max}, firstEdit))
      }
      this.firstEdit = false
    },
    updateGroupCount (groupId, count) {
      this.countList = this.countList.map(x => {
        const isGroup = x.groupId === groupId
        return {
          ...x,
          count: isGroup
            ? count
            : x.count
        }
      })
    },
    isValidConfirm () {
      const groupId = this.setCount
      const group = this.countList.find(x => x.groupId === groupId)

      const count = group && group.count

      const isEmpty =
        count === null ||
        count === '' ||
        typeof count === 'undefined'

      return !isEmpty
    },
    close () {
      this.$emit('close')
    }

  }
}
</script>